<template>
    <div className="tw-w-full tw-mx-auto 3xl:tw-max-w-screen-3xl 4xl:tw-max-w-screen-4xl tw-px-4 md:tw-px-8">
        <Breadcrumb :breadcrumbs="breadcrumbs"/>
        <PageHeader
            title="Challenges"
            icon-name="challenges"
            description="Challenges are a collection of Workout-style videos that build your skills one step at a time. They help you develop broader musical skills at a manageable pace — usually over a few days."
        />

        <div className="tw-mt-[30px]">
            <!-- Challenge Carousel -->
            <MiniCatalogueSection
                v-if="carousels.length > 0"
                title="Featured Challenges"
                catalogue-type="challenge-carousel"
                page-type="challenge"
                :preLoadedContent="carousels"
                :auto-scroll="true"
            />

            <CollectionWrapper
                collection-type="challenge"
                :hide-filter-icon="true"
                :hide-search="true"
                :tab-options="tabData"
            />
        </div>
    </div>
</template>
<script setup>
import { computed, onBeforeMount, ref } from "vue";
import { storeToRefs } from "pinia/dist/pinia";
import { useUserStore } from "@stores/user";
import { usePlatformStore } from "@stores/platform";
import { useCollectionStore } from "@stores/collection";
import { fetchCarouselCardData } from 'musora-content-services';

import Breadcrumb from '@collections/Breadcrumb/Breadcrumb';
import PageHeader from '@collections/PageHeader/PageHeader';
import CollectionWrapper from '@collections/CollectionWrapper/CollectionWrapper';
import MiniCatalogueSection from '@collections/MiniCatalogueSection/MiniCatalogueSection';

const collectionStore = useCollectionStore();
const userStore = useUserStore();
const platformStore = usePlatformStore();
const { brand } = storeToRefs(userStore);

const breadcrumbs = [{title: 'Challenges'}];
const carousels = ref([]);

const tabData = computed(() => {
    if (brand.value === 'drumeo' || brand.value === 'pianote') {
        return [
            {
                value: 'All',
                groupByView: false,
                key: '',
            },
            {
                value: 'Skill Level',
                groupByView: true,
                key: [''],
            },
            {
                value: 'Genres',
                groupByView: true,
                key: ['genre'],
            },
            {
                value: 'Completed',
                groupByView: false,
                key: [''],
            },
            {
                value: 'Owned Challenges',
                groupByView: false,
                key: [''],
            },
        ]
    } else {
        return [
            {
                value: 'Completed',
                groupByView: false,
                key: [''],
            },
            {
                value: 'Owned Challenges',
                groupByView: false,
                key: [''],
            },
        ]
    }
})

onBeforeMount(() => {
    const fetchData = async () => {
        const challengeCarousels = await fetchCarouselCardData(brand.value);

        if (challengeCarousels) {
            carousels.value = challengeCarousels.filter((carousel) => {
                return carousel.show_everywhere;
            });
        }

        collectionStore.setDefaults({
            tabOptions: tabData.value,
            queryType: 'challenge',
        });
    }

    fetchData();
})
</script>
